// Profile related constants
export const EXCHANGES = ['MCX', 'NFO', 'CDS', 'DCSX'];

// Instrument exchange → its session_name in the exchange session info API.
// type 'daily' trades Mon - Fri, 'daily_all_days' every day.
export const EXCHANGE_SESSION_BY_EXCHANGE = {
  NSE: { sessionName: 'amo-nse-cm', type: 'daily' },
  BSE: { sessionName: 'amo-bse-cm', type: 'daily' },
  NFO: { sessionName: 'amo-nse-fo', type: 'daily' },
  BFO: { sessionName: 'amo-bse-fo', type: 'daily' },
  MCX: { sessionName: 'amo-mcx-fo', type: 'daily' },
  CDS: { sessionName: 'amo-nse-cd', type: 'daily' },
  DCSX: { sessionName: 'amo-crypto-cm', type: 'daily_all_days' },
};

// Profile Exchange & Market Status rows; `code` is matched against exchanges_subscribed
export const EXCHANGE_SESSION_ROWS = [
  { code: 'NSE', label: 'NSE', ...EXCHANGE_SESSION_BY_EXCHANGE.NSE },
  { code: 'NFO', label: 'NFO', ...EXCHANGE_SESSION_BY_EXCHANGE.NFO },
  { code: 'BSE', label: 'BSE', ...EXCHANGE_SESSION_BY_EXCHANGE.BSE },
  { code: 'BFO', label: 'BFO', ...EXCHANGE_SESSION_BY_EXCHANGE.BFO },
  { code: 'MCX', label: 'MCX', ...EXCHANGE_SESSION_BY_EXCHANGE.MCX },
  { code: 'CDS', label: 'CDS', ...EXCHANGE_SESSION_BY_EXCHANGE.CDS },
  { code: 'DCSX', label: 'DCSX', ...EXCHANGE_SESSION_BY_EXCHANGE.DCSX },
  // US stocks trade under CDS, so their subscription follows CDS
  { code: 'CDS', label: 'US STOCK', sessionName: 'amo-us-stock', type: 'daily' },
];

export const TAB_LABELS = {
  ACCOUNT_DETAILS: 'Account Details',
  PREFERENCES: 'Preferences',
};

export const TAB_INDICES = {
  ACCOUNT_DETAILS: 0,
  PREFERENCES: 1,
};

export const SNACKBAR_DURATION = 3000;

export const SCROLL_THRESHOLD = 300;

export const WELCOME_MESSAGE_DURATION = 5000;

export const REFERRAL_URL_FALLBACK = 'https://tradex.live/ref/R00049';

export const ANIMATION_DURATION = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500,
};

export const BREAKPOINTS = {
  MOBILE: 'sm',
  TABLET: 'md',
  DESKTOP: 'lg',
};

